import { STATUS_TYPES } from "../../components/branch-deployer/BranchDeployer.consts";

const compareBranchDeployerRows = (a, b) => {
  const aIsLive = a.status === STATUS_TYPES.LIVE;
  const bIsLive = b.status === STATUS_TYPES.LIVE;
  if (aIsLive !== bIsLive) return aIsLive ? -1 : 1;
  return (b.lastUpdated ?? 0) - (a.lastUpdated ?? 0);
};

let lastRows = null;
let lastSortedRows = null;
export const branchDeployerRowsSelector = state => {
  const rows = state.branchDeployerRows;
  if (!rows) return rows;
  if (rows !== lastRows) {
    lastRows = rows;
    lastSortedRows = [...rows].sort(compareBranchDeployerRows);
  }
  return lastSortedRows;
};
export const branchesReleaseNamesSelector = state => state.branchDeployerRows?.map(branch => branch.releaseName);
export const getBranchDeployerRowsSelector = state => state.getBranchDeployerRows;
export const createBranchDeployerSelector = state => state.createBranchDeployer;
export const editBranchDeployerSelector = state => state.editBranchDeployer;
export const deleteBranchDeployerSelector = state => state.deleteBranchDeployer;
export const getBranchDeployerStatusSelector = state => state.getBranchDeployerStatus;
export const branchDeployerErrorSelector = state => state.branchDeployerError;
export const setBranchDeployerErrorSelector = state => state.setBranchDeployerError;
